module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "logo.0a6936ba.svg";